import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyM, LabelS } from 'atoms/typography';

const LogoContainer = styled.div`
  width: var(--triple-unit);
  text-align: center;
`;
const Logo = styled.img`
  height: var(--triple-unit);
`;

export type Props = {
  club: {
    slug: string;
    name: string;
    pictureUrl: string | null;
    to: string;
    competition?: {
      name: string;
      to: string;
    };
  };
};

export const RelatedClub = ({ club }: Props) => {
  return (
    <Horizontal>
      <LogoContainer>
        {!!club.pictureUrl && <Logo src={club.pictureUrl} alt={club.name} />}
      </LogoContainer>
      <Vertical gap={0}>
        <BodyM as="p">
          <Link to={club.to}>{club.name}</Link>
        </BodyM>
        {!!club.competition && (
          <Link to={club.competition.to}>
            <LabelS as="p" color="var(--c-nd-600)">
              {club.competition.name}
            </LabelS>
          </Link>
        )}
      </Vertical>
    </Horizontal>
  );
};
